VjsAdmin.BulkTasks = (() => {
    const BulkTasksController = VjsUtility.View.extend({
        events: {
            'change #task-select': 'changeTask',
        },
        changeTask: () => {
            if ($('#task-select').val() === 'roster-mapping') {
                VjsAdmin.RosterMapping.init();
            }
        },
    });

    const applyGetParams = () => {
        const queryString = window.location.search;

        if (queryString) {
            const urlParams = new URLSearchParams(queryString);

            if (urlParams.has('task')) {
                const task = urlParams.get('task');
                $('#task-select').val(task).trigger('change');
            }
        }
    };

    const init = () => {
        new BulkTasksController();
        applyGetParams();
    };

    return {
        init,
    };
})();
